import { useCallback, useState } from 'react';

import { HISTORY_MODAL_TITLE } from '@app/pages/TasksList/constants/modalTitles';

export const useHistoryModal = () => {
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);

  const historyModalTitle = <>{HISTORY_MODAL_TITLE}</>;

  const openHistoryModal = useCallback(() => {
    setIsHistoryModalOpen(true);
  }, []);

  const closeHistoryModal = useCallback(() => {
    setIsHistoryModalOpen(false);
  }, []);
  return {
    isHistoryModalOpen,
    historyModalTitle,
    openHistoryModal,
    closeHistoryModal,
  };
};
